<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :selectShow="false"
    >
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="chnCode"
        label="线路名称"
        min-width="230"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="bankAbbrName"
        label="银行名称"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="bankAbbr"
        label="银行简称"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="repayPlanTime"
        label="repayPlanTime（1、2轮时间）"
        min-width="280"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="repayPlanHour1"
        label="repayPlanHour1（第一个时间）"
        min-width="280"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="repayPlanHour2"
        label="repayPlanHour2（第二个时间）"
        min-width="280"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="repayPlanSpace"
        label="repayPlanSpace（二笔偏移）"
        min-width="280"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="startMinute"
        label="startMinute(首笔偏移)"
        min-width="280"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="roundPerDate"
        label="roundPerDate（几还）"
        min-width="280"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="180"
        show-overflow-tooltip
        :formatter="typeCardWithdrawalStatus"
      ></el-table-column>
      <el-table-column label="操作" min-width="160">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="handleDelete(scope.row)"
            class="button-color"
            >删除
          </el-button>
          <el-button type="text" @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button
            type="text"
            @click="handleShow(scope.row.id, scope.row.status)"
            class="button-color"
            >{{ scope.row.status == 1 ? "禁用" : "启用" }}
          </el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      labelWidth="120px"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
      dialogWidth="800px"
    >
      <el-form-item label="通道代码" prop="chnId" label-width="500px">
        <el-input
          disabled
          type="text"
          show-word-limit
          v-model="dialogModel.chnId"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="银行" prop="bankAbbr" label-width="500px">
        <el-select
          v-model="dialogModel.bankAbbr"
          filterable
          :disabled="itemId == '' ? false : true"
        >
          <el-option
            v-for="item in bankTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="repayPlanTime（1、2轮时间）"
        prop="repayPlanTime"
        label-width="500px"
      >
        <el-input
          type="text"
          show-word-limit
          v-model="dialogModel.repayPlanTime"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="repayPlanHour1（第一个时间）"
        prop="repayPlanHour1"
        label-width="500px"
      >
        <el-input
          type="text"
          show-word-limit
          v-model="dialogModel.repayPlanHour1"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="repayPlanHour2（第二个时间）"
        prop="repayPlanHour2"
        label-width="500px"
      >
        <el-input
          type="text"
          show-word-limit
          v-model="dialogModel.repayPlanHour2"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="repayPlanSpace（二笔偏移）"
        prop="repayPlanSpace"
        label-width="500px"
      >
        <el-input
          type="text"
          show-word-limit
          v-model="dialogModel.repayPlanSpace"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="startMinute(首笔偏移)"
        prop="startMinute"
        label-width="500px"
      >
        <el-input
          type="text"
          show-word-limit
          v-model="dialogModel.startMinute"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="roundPerDate（几还）"
        prop="roundPerDate"
        label-width="500px"
      >
        <el-input
          type="text"
          show-word-limit
          v-model="dialogModel.roundPerDate"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import APPService from "service/APPService";
import Regs from "common/conf/Regs";
import TimeRange from "service/constant/TimeRange";
import {
  encrypt,
  urlEncode,
  objKeySort,
  debounce,
} from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "customconfiguration",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      formModel: {
        phone: "",
        remark: "",
      },
      tableData: [],
      bankTypes: [],
      time: "",
      submitService: APPService.customconfigurationList,
      page: {},
      isPage: false,
      itemId: "",
      dialogModel: {
        chnId: "",
        repayPlanTime: "",
        repayPlanHour1: "",
        repayPlanHour2: "",
        repayPlanSpace: "",
        startMinute: "",
        roundPerDate: "",
        bankAbbr: "",
      },
      dialogRules: {
        bankAbbr: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择"));
              } else {
                this.getBankYz(value, (res) => {
                  if (res.contents.checkFlag == true) {
                    if (this.itemId != "") {
                      callback();
                    }
                    callback(new Error("以重复重新选择"));
                  } else {
                    callback();
                  }
                });
              }
            },
          },
        ],
        repayPlanTime: [
          {
            required: true,
            message: "请输入",
          },
        ],
        repayPlanHour1: [
          {
            required: true,
            message: "请输入",
          },
        ],
        repayPlanHour2: [
          {
            required: true,
            message: "请输入",
          },
        ],
        repayPlanSpace: [
          {
            required: true,
            message: "请输入",
          },
        ],
        startMinute: [
          {
            required: true,
            message: "请输入",
          },
        ],
        roundPerDate: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      isFlag: false,
      info: "",
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.info = this.$route.params.info;
    this.getTypeNames("bankAbbreviation", (res) => {
      this.bankTypes = [...res];
    });
    this.load();
  },
  computed: {
    submitData() {
      this.params = {
        chnId: this.info,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    dialogData() {
      const params = {
        chnId: this.dialogModel.chnId,
        repayPlanTime: this.dialogModel.repayPlanTime,
        repayPlanHour1: this.dialogModel.repayPlanHour1,
        repayPlanHour2: this.dialogModel.repayPlanHour2,
        repayPlanSpace: this.dialogModel.repayPlanSpace,
        startMinute: this.dialogModel.startMinute,
        roundPerDate: this.dialogModel.roundPerDate,
        bankAbbr: this.dialogModel.bankAbbr,
      };
      this.bankTypes.forEach((item) => {
        if (this.dialogModel.bankAbbr == item.dictKey) {
          params.bankAbbrName = item.dictValue;
        }
      });
      if (this.itemId) {
        params.id = this.itemId;
      }
      // console.log(params);
      return params;
    },
    dialogService() {
      return this.itemId
        ? APPService.customconfigurationEdit
        : APPService.customconfigurationInsert;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    "dialogRules.bankAbbr"(val, oldVal) {
      console.log(val);
    },
  },
  methods: {
    load() {
      this.formModel = {
        time: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    handleDelete(item) {
      this.showConfirm("确定删除此数据？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        APPService.customconfigurationDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item) {
      this.dialogModel.chnId = this.info;
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
      this.$nextTick(() => {
        this.$refs.formDialog.clearValidate();
      });
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    getBankYz(val, onSuccess) {
      const params = {
        chnId: this.info,
        bankAbbr: val,
      };
      this.doLoad(
        APPService.bankNameYz,
        params,
        (res) => {
          onSuccess && onSuccess(res);
        },
        "信息获取失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        chnId: "",
        repayPlanTime: "",
        repayPlanHour1: "",
        repayPlanHour2: "",
        repayPlanSpace: "",
        startMinute: "",
        roundPerDate: "",
        bankAbbr: "",
      };
    },
    handleShow(id, status) {
      const title = status == 1 ? "是否禁用？" : "是否启用？";
      this.showConfirm(title)
        .then(() => {
          const params = {
            id: id,
            status: status == 1 ? 0 : 1,
          };
          this.doLoad(
            APPService.status,
            params,
            (res) => {
              this.doCheck(res, (res) => {
                this.showSuccess(res.respMsg);
                this.getList();
              });
            },
            "信息获取失败"
          );
        })
        .catch(() => {});
    },
    typeCardWithdrawalStatus: function (row, column) {
      switch (row.status) {
        case "0":
          return "禁用";
          break;
        case "1":
          return "启用";
          break;
        default:
          return "--";
      }
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 110px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
</style>




// WEBPACK FOOTER //
// src/view/page/ChannelManage/CustomConfiguration.vue